import { Pipe, PipeTransform } from '@angular/core';
import { DateHelper } from '@app/date-helper';

@Pipe({
  name: 'dayToDate',
  standalone: true,
})
export class DayToDatePipe implements PipeTransform {
  public transform(
    i: number,
    month: number,
    startDay: number,
    year: number
  ): string {
    let date = DateHelper.createUTCDate(year, month, i - startDay);
    return date.toISOString();
  }
}
